import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { CapacidadPagoComponent } from './capacidad-pago.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { IMaskModule } from 'angular-imask';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CapacidadPagoOpcionesComponent } from './capacidad-pago-opciones/capacidad-pago-opciones.component';
import { CapacidadPagoProcesoComponent } from './capacidad-pago-proceso/capacidad-pago-proceso.component';
import { CesionCupoComponent } from './cesion-cupo/cesion-cupo.component';
import { DesistirNominacionComponent } from './desistir-nominacion/desistir-nominacion.component';
import { EditCpComponent } from './edit-cp/edit-cp.component';

import { ProcesoAdjudicadoCanceladoComponent } from './../proceso-adjudicado-cancelado/proceso-adjudicado-cancelado.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { RolesGuard } from 'src/app/guards/roles.guard';
import { StepsGuard } from 'src/app/guards/steps.guard';

const routes: Routes = [
  { path: 'capacidad-pago', component: CapacidadPagoComponent, canActivate: [RolesGuard, StepsGuard], data: {roles: ['Cliente', 'Codeudor'], steps: [3]} },
  { path: 'capacidad-pago/:id', component: CapacidadPagoComponent/* , canActivate: [LoginGuard] */ },
  { path: 'proceso-capacidad-pago/:id', component: CapacidadPagoProcesoComponent },
  { path: 'opciones-capacidad-pago', component: CapacidadPagoOpcionesComponent },
  { path: 'cesion-cupo', component: CesionCupoComponent },
  { path: 'desistir-nominacion', component: DesistirNominacionComponent , canActivate: [RolesGuard], data: {roles: ['Cliente', 'Codeudor','Asesor integral']}},
  { path: 'capacidad-pago-edit/:id', component: EditCpComponent},
  { path: 'continuidad-proceso', component: ProcesoAdjudicadoCanceladoComponent }
];

@NgModule({
  declarations: [
    CapacidadPagoComponent,
    CapacidadPagoProcesoComponent,
    CapacidadPagoOpcionesComponent,
    CesionCupoComponent,
    DesistirNominacionComponent,
    EditCpComponent

  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbDatepickerModule,
    NgSelectModule,
    IMaskModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    NgxSpinnerModule,
    FontAwesomeModule,
    SharedModule
  ],
  exports: [CapacidadPagoComponent, EditCpComponent]
})
export class CapacidadPagoModule { }
